/**
 * @module actions/notes
 */
import axios from 'axios'
import {
  API_URL
  // FILE_STORAGE_API
} from '../constants'

/**
 * @description Creating an note using the API
 * @return {Promise} Axios promise
 */
export function postNote (data) {
  let url = API_URL + '/Notes/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Deleting an note using the API
 * @return {Promise} Axios promise
 */
export function deleteNote (id) {
  let url = API_URL + '/Notes/Delete/' + id
  return dispatch => {
    return axios.post(url, {})
  }
}



// WEBPACK FOOTER //
// ./src/app/actions/generalnotes.js